/**************************************************
 * Nombre:       DetalleComercio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {useState} from 'react';
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_Formularios/Hooks/useFormulario";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import F_Pqrs from "../../Pagina/Formularios/F_Pqrs";
import {Google, Whatsapp} from "iconsax-react";
import {enviarMensajeEmail, enviarMensajeWhatsapp, verificarNumeroCelular} from "../../Utilidades";


const DetallePqrs = ({id: item, cerrar}) => {
    const {Formulario, props, entidad} = useFormulario({Form: F_Pqrs, nombre: "local", datosDefault: item})
    const [cargando, setCargando] = useState(false)

    const guardarCambios = () => {
        setCargando(true)
        guardarDoc("locales", entidad).then((dox) => {
            if (dox.res) {
                alert("cambios guardados con exito")
                cerrar()
            } else {
                alert("Error al guardar cambios, intentelo mas tarde")
            }
            setCargando(false)
        })
    }

    const borrarPqrs = () => {
        borrarDoc("pqrs", entidad).then((dox) => {
            if (dox.res) {
                alert("Comercio borrado con exito")
                cerrar()
            } else {
                alert("Error al borrar comercio, intentelo mas tarde")
            }
        })
    }

    const responderToWhatsapp = () => {
        if (verificarNumeroCelular(item.celular)) {
            let num = item.celular;
            enviarMensajeWhatsapp(num, "")
        }
    }
    const responderToEmail = () => {
        enviarMensajeEmail(item.correo, "Respuesta de PQRS", "")
    }


    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
        >

            <Grid item lg={12} sm={12} xs={12}>
                <Button
                    onClick={() => borrarPqrs()}
                    color={"success"} variant={"outlined"} size={"small"}>Borrar</Button>
            </Grid>

            <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: "center", marginTop: 3}}>
                <Formulario {...props}/>
            </Grid>

            <Grid item lg={6} sm={12} xs={12} sx={{marginTop: 2}}>
                <Button
                    onClick={() => responderToWhatsapp()}
                    startIcon={<Whatsapp variant={"Bold"}/>}>Responder</Button>
            </Grid>

            <Grid item container lg={6} sm={12} xs={12} sx={{justifyContent: "flex-end", marginTop: 2}}>
                <Button
                    onClick={() => responderToEmail()}
                    color={"secondary"} startIcon={<Google variant={"Bold"}/>}>Responder</Button>
            </Grid>


        </Grid>
    )
}

export default DetallePqrs;